import { v4 as uuid } from 'uuid'

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/card/mobile/img-1_r-etBUfM1.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1645964004885',
    cardHead: 'APPLE iPhone 12 (Black, 64 GB)',
    cardDesc: '1,58,616 Ratings & 10,880 Reviews',
    cardRating: '3.8',
    cardDiscPrice: '60199',
    cardMainPrice: '65900',
    cardDiscPer: '8',
    inStock: false,
    fastDelivery: true,
    categoryName: 'mobiles',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/mobiles/img-4_w0pz0mXkY.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1646379117993',
    cardHead: 'Realme 8 (Cyber Black, 128 GB)',
    cardDesc: '75,193 Ratings & 7,285 Reviews',
    cardRating: '4.3',
    cardDiscPrice: '15999',
    cardMainPrice: '16999',
    cardDiscPer: '5',
    inStock: true,
    fastDelivery: true,
    categoryName: 'mobiles',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/mobiles/img-5_NHazGnpl-.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647436904889',
    cardHead: 'Xiaomi 11i (Camo Green, 128 GB)',
    cardDesc: '9,641 Ratings & 1,270 Reviews',
    cardRating: '4.2',
    cardDiscPrice: '24999',
    cardMainPrice: '29999',
    cardDiscPer: '16',
    inStock: true,
    fastDelivery: false,
    categoryName: 'mobiles',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/mobiles/img-6_pNGE3r11c.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647437436046',
    cardHead: 'SAMSUNG Galaxy S21 (Graphite, 128 GB)',
    cardDesc: '96 Ratings & 10 Reviews',
    cardRating: '3',
    cardDiscPrice: '54990',
    cardMainPrice: '57999',
    cardDiscPer: '5',
    inStock: true,
    fastDelivery: false,
    categoryName: 'mobiles',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/watches/img-2_90KzXDoEt.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647437983683',
    cardHead: 'APPLE Watch Series 3 GPS 38 mm',
    cardDesc: '50,052 Ratings & 4,493 Reviews',
    cardRating: '4.6',
    cardDiscPrice: '16900',
    cardMainPrice: '20900',
    cardDiscPer: '19',
    inStock: false,
    fastDelivery: false,
    categoryName: 'watches',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/watches/img-3_drN6cC-2D.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647438316003',
    cardHead: 'Huami Amazfit Pace Smartwatch',
    cardDesc: '536 Ratings & 81 Reviews',
    cardRating: '4.2',
    cardDiscPrice: '9999',
    cardMainPrice: '10999',
    cardDiscPer: '9',
    inStock: true,
    fastDelivery: true,
    categoryName: 'watches',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/watches/img-4_J6ajr70-N.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647438697733',
    cardHead: 'SAMSUNG Galaxy Watch 46 mm',
    cardDesc: '12,178 Ratings & 1,606 Reviews',
    cardRating: '4.5',
    cardDiscPrice: '16990',
    cardMainPrice: '33999',
    cardDiscPer: '50',
    inStock: true,
    fastDelivery: true,
    categoryName: 'watches',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/watches/img-5_emZCdXZmQ.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647438978403',
    cardHead: 'FITBIT Versa Lite Edition Smartwatch',
    cardDesc: '427 Ratings & 45 Reviews',
    cardRating: '4.2',
    cardDiscPrice: '15999',
    cardMainPrice: '16999',
    cardDiscPer: '5',
    inStock: true,
    fastDelivery: false,
    categoryName: 'watches',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/laptops/img-4_gnXGqvKcd.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1646379119525',
    cardHead: 'ASUS VivoBook Ultra Ryzen 7',
    cardDesc: '60 Ratings & 6 Reviews',
    cardRating: '4.4',
    cardDiscPrice: '67990',
    cardMainPrice: '84990',
    cardDiscPer: '20',
    inStock: false,
    fastDelivery: false,
    categoryName: 'laptops',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/laptops/img-5_h_2-yM49V.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647439500122',
    cardHead: 'Acer Aspire 7 Ryzen 5 Hexa Core 5500U',
    cardDesc: '3,087 Ratings & 404 Reviews',
    cardRating: '4.5',
    cardDiscPrice: '54990',
    cardMainPrice: '89000',
    cardDiscPer: '38',
    inStock: true,
    fastDelivery: false,
    categoryName: 'laptops',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/laptops/img-6_j62kc3piG.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647439693030',
    cardHead: 'ASUS TUF Gaming F15 (2021) Core i5 11th Gen',
    cardDesc: '99 Ratings & 15 Reviews',
    cardRating: '4.7',
    cardDiscPrice: '85990',
    cardMainPrice: '129990',
    cardDiscPer: '33',
    inStock: true,
    fastDelivery: true,
    categoryName: 'laptops',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/laptops/img-7_Nyh_poPb4.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647440113632',
    cardHead: 'HP Ryzen 3 Dual Core 3250U 15s-GY0501AU',
    cardDesc: '2,108 Ratings & 232 Reviews',
    cardRating: '4.3',
    cardDiscPrice: '38490',
    cardMainPrice: '46055',
    cardDiscPer: '16',
    inStock: true,
    fastDelivery: true,
    categoryName: 'laptops',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/cameras/img-3_psDsHjtIT.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647445529147',
    cardHead: 'Canon EOS 1500D DSLR Camera Body',
    cardDesc: '12,699 Ratings & 1,836 Reviews',
    cardRating: '4.5',
    cardDiscPrice: '36499',
    cardMainPrice: '39995',
    cardDiscPer: '8',
    inStock: false,
    fastDelivery: false,
    categoryName: 'cameras',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/cameras/img-1_Em18snD14.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1646379119858',
    cardHead: 'Panasonic Lumix Series Lumix DC-S1RMGA',
    cardDesc: '365 Ratings & 10 Reviews',
    cardRating: '4.0',
    cardDiscPrice: '39899',
    cardMainPrice: '42999',
    cardDiscPer: '7',
    inStock: true,
    fastDelivery: false,
    categoryName: 'cameras',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/cameras/img-4_VvmzjU7Eg.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647445838087',
    cardHead: 'GoPro Hero9 Sports and Action Camera',
    cardDesc: '622 Ratings & 57 Reviews',
    cardRating: '4.2',
    cardDiscPrice: '36999',
    cardMainPrice: '47000',
    cardDiscPer: '21',
    inStock: true,
    fastDelivery: true,
    categoryName: 'cameras',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/products/cameras/img-5_sDTXA_mt2.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647446016494',
    cardHead: 'FUJIFILM Instax Mini 9 Instant Camera',
    cardDesc: '1,965 Ratings & 140 Reviews',
    cardRating: '4.4',
    cardDiscPrice: '3999',
    cardMainPrice: '5530',
    cardDiscPer: '27',
    inStock: true,
    fastDelivery: true,
    categoryName: 'cameras',
  },
]

export const newArrivals = [
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/card/mobile/img-1_r-etBUfM1.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1645964004885',
    cardHead: 'APPLE iPhone 12 (Black, 64 GB)',
    cardDesc: '1,58,616 Ratings & 10,880 Reviews',
    cardRating: '3',
    cardDiscPrice: '60199',
    cardMainPrice: '65900',
    cardDiscPer: '8',
    inStock: true,
    fastDelivery: true,
    categoryName: 'mobile',
  },
  {
    _id: uuid(),
    cardImg:
      'https://ik.imagekit.io/tanishq20/assets/card/mobile/img-1_r-etBUfM1.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1645964004885',
    cardHead: 'APPLE iPhone 12 (Black, 64 GB)',
    cardDesc: '1,58,616 Ratings & 10,880 Reviews',
    cardRating: '3',
    cardDiscPrice: '₹60199',
    cardMainPrice: '₹65900',
    cardDiscPer: '8',
    inStock: true,
    fastDelivery: false,
    categoryName: 'mobile',
  },
]
